import msci_c from './msci.js'
import jgdy from './new_opinion.js'
import jgdy1 from './opinion.js'

const arr = [{ //产品模块列表
    path: 'list',
    component: resolve => {
      require(['../../../views/inner/product/list.vue'], resolve)
    }
  },
  { //巨丰牛股
    path: 'jfng',
    component: resolve => {
      require(['../../../views/inner/product/jfng.vue'], resolve)
    }
  },
  { //业务部自定义
    path: 'custom',
    component: resolve => {
      require(['../../../views/inner/product/custom.vue'], resolve)
    }
  },
  { //财经大咖
    path: 'cjdk',
    name: 'cjdk',
    component: resolve => {
      require(['../../../views/inner/product/cjdk.vue'], resolve)
    }
  },
  {
    path: 'cjdk-details',
    name: 'cjdk-details',
    component: resolve => {
      require(['../../../views/inner/product/cjdk-details.vue'], resolve)
    }
  },
  { //涨停统计
    path: 'zttj',
    component: resolve => {
      require(['../../../views/inner/product/zttj.vue'], resolve)
    }
  },
  { //涨停擒龙
    path: 'ztql',
    component: resolve => {
      require(['../../../views/inner/product/zyql/index.vue'], resolve)
    }
  },
  { //涨停板解密
    path: 'ztbjm',
    name: 'ztbjm-details',
    component: resolve => {
      require(['../../../views/inner/product/ztbjm/index.vue'], resolve)
    }
  },
  { //涨停板解密详情
    path: 'ztbjm-list',
    name: 'ztbjm-list',
    component: resolve => {
      require(['../../../views/inner/product/ztbjm/list.vue'], resolve)
    }
  },
  { //投顾策略
    path: 'tgcl',
    component: resolve => {
      require(['../../../views/inner/product/tgcl/base.vue'], resolve)
    },
    children: [{ //投顾策略列表
        path: 'list',
        component: resolve => {
          require(['../../../views/inner/product/tgcl/list.vue'], resolve)
        }
      },
      { //投顾策略列表详情
        path: 'details',
        component: resolve => {
          require(['../../../views/inner/product/tgcl/details.vue'], resolve)
        }
      }
    ]
  },
  { //试听解盘
    path: 'pmjd',
    component: resolve => {
      require(['../../../views/inner/product/pmjd/base.vue'], resolve)
    },
    children: [{ //投顾策略列表
        path: 'index',
        component: resolve => {
          require(['../../../views/inner/product/pmjd/index.vue'], resolve)
        },
        meta:{
        	keepAlive:true
        }
      },
      { //投顾策略列表详情
        path: 'details',
        component: resolve => {
          require(['../../../views/inner/product/pmjd/details.vue'], resolve)
        }
      }
    ]
  },
  { //主题投资
    path: 'zttz',
    component: resolve => {
      require(['../../../views/inner/product/zttz/base.vue'], resolve)
    },
    children: [{ //主题投资首页
        path: 'index',
        component: resolve => {
          require(['../../../views/inner/product/zttz/index.vue'], resolve)
        },
        meta:{
	      	keepAlive:true
	      }
     },
      { //主题投资列表
        path: 'list',
        component: resolve => {
          require(['../../../views/inner/product/zttz/list.vue'], resolve)
        }
      },
      { //主题投资详情
        path: 'details',
        name: 'invesment-details',
        component: resolve => {
          require(['../../../views/inner/product/zttz/details.vue'], resolve)
        }
      },
      { //主题投资文章推荐页
        path: 'article',
        name: 'invesment-article',
        component: resolve => {
          require(['../../../views/inner/product/zttz/article.vue'], resolve)
        }
      },
      { //主题投资最新详情页
        path: 'invesment-new-details',
        name: 'invesment-new-details',
        component: resolve => {
          require(['../../../views/inner/product/zttz/newDetails.vue'], resolve)
        }
      }
    ]
  },
  { //看好中国
    path: 'khzg',
    component: resolve => {
      require(['../../../views/inner/product/khzg/base.vue'], resolve)
    },
    children: [{ //看好中国首页
        path: 'index',
        component: resolve => {
          require(['../../../views/inner/product/khzg/index.vue'], resolve)
        }
      },
      { //看好中国列表
        path: 'list',
        component: resolve => {
          require(['../../../views/inner/product/khzg/list.vue'], resolve)
        }
      },
      { //看好中国样本股
        path: 'demoStock',
        component: resolve => {
          require(['../../../views/inner/product/khzg/demoStock.vue'], resolve)
        }
      },
      { //看好中国详情
        path: 'details',
        component: resolve => {
          require(['../../../views/inner/product/khzg/details.vue'], resolve)
        }
      }
    ]
  },
  { //msci中国
    path: 'msci',
    component: resolve => {
      require(['../../../views/inner/product/msci/base.vue'], resolve)
    },
    children: msci_c
  },
  { //机构调研
    path: 'new_opinion',
    component: resolve => {
      require(['../../../views/inner/product/new_opinion/base.vue'], resolve)
    },
    children: jgdy
  },
  { //opinion类
    path: 'opinion',
    component: resolve => {
      require(['../../../views/inner/product/opinion/base.vue'], resolve)
    },
    children: jgdy1
  },
  { //智库锦囊-十九个大师
    path: 'wisdom_tank',
    component: resolve => {
      require(['../../../views/inner/product/wisdomTank.vue'], resolve)
    }
  },
  { //赢在买点详情页
    path: 'yzmd_detail/:id',
    component: resolve => {
      require(['../../../views/inner/product/videoModule/yzmd.vue'], resolve)
    }
  },
  { //赢在买点详情页
    path: 'yzpq_detail/:id',
    component: resolve => {
      require(['../../../views/inner/product/videoModule/yzpq.vue'], resolve)
    }
  },
  { //智库锦囊
    path: 'wisdomTank',
    component: resolve => {
      require(['../../../views/inner/product/wisdomTank.vue'], resolve)
    }
  },
  {
    path: 'iframe_page',
    name: 'iframe_page',
    component: resolve => {
      require(['../../../views/inner/product/webview/index.vue'], resolve)
    }
  }
]

export default arr



// WEBPACK FOOTER //
// ./src/router/inner/product/index.js